<template>
<div>
<el-container class="data_skc">
	<el-aside class="aside-style" width="200px">
		<common-nav selec="3"></common-nav>
	</el-aside>
	<el-container>
		<el-header class="common_header">
			<common-header></common-header>
		</el-header>
		<el-main>

			<el-row :gutter="24" class="page_bar">
				<el-col :span="22" class="page_bar_title">问题反馈</el-col>
				<el-col :span="2"><el-button icon="el-icon-chat-line-round" type="success" size="small" @click="handleNewfeedback">提问</el-button></el-col>
				<!-- <el-col :span="6">
					<el-input placeholder="输入标题查找" v-model="searchValue" class="input-with-select" size="small" >
						<el-button slot="append" icon="el-icon-search"></el-button>
					</el-input>
				</el-col> -->
			</el-row>

			<el-table :data="tableData">
				<el-table-column prop="status" label="状态">
					<template slot-scope="scope">
						<label v-if="scope.row.status == 1">待回复</label>
						<label v-if="scope.row.status == 2" style="color:green">已回复</label>
					</template>
				</el-table-column>
				<el-table-column prop="body" label="问题描述" width="500">
						<template slot-scope="scope">
						{{ scope.row.body==null?'':(scope.row.body.length>100?scope.row.body.substring(0,40)+'...':scope.row.body) }}
						</template>
					</el-table-column>
				<el-table-column prop="add_date" label="创建日期" ></el-table-column>
				<el-table-column label="操作" fixed="right">
					<template slot-scope="scope">
						<el-button type="primary" @click="handleDetail(scope.row)" size="mini" plain>详情</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-main>
		<el-footer>copyright &copy; subudian.com</el-footer>
	</el-container>
</el-container>

<el-dialog title="系统问题反馈" :close-on-click-modal="false" width="50%"  :visible.sync="dialogNewfeedbackVisible">
	<el-row :gutter="20" class="sixo">
		<el-col :span="24"><span class="red_dot">*</span>请简要描述您遇到的问题：
		<el-input type="textarea" class="sxxx"  maxlength="500" show-word-limit :rows="5" v-model="feedback_body" placeholder="请输入内容"></el-input></el-col>
	</el-row>
	<div slot="footer" class="dialog-footer">
		<el-button @click="dialogNewfeedbackVisible = false">取 消</el-button>
		<el-button type="primary" @click="handleSaveNewFeedback">确 定</el-button>
	</div>
</el-dialog>

<el-dialog title="问题反馈详情" :close-on-click-modal="false" width="70%"  :visible.sync="dialogDetailfeedbackVisible">
	<el-card shadow="always" class="card_sx" >
		<div class="dil_body">{{feedback_detail.body}}</div>
		<div class="dil_date">{{feedback_detail.add_date}}</div>
    </el-card>
	<el-card shadow="always" class="card_sx"  v-for="(item, index) in feedback_follow" key="feedback_follow" >
		<div class="dil_date"><span class="dox_ito">问题回复</span> {{item.add_date}}</div>
		<div class="dil_body">{{item.body}}</div>
    </el-card>
</el-dialog>


</div>
</template>

<script>
import CommonNav from "@/components/Nav.vue";
import CommonHeader from "@/components/Header.vue";
import * as MN from '@/api/common'

export default {
    name: 'sysset',
	props:['selec'],
	data() {
		return {
			feedback_detail:[],
			feedback_follow:[],
			dialogDetailfeedbackVisible:false,
			feedback_body:"",
			stafflog_title:'操作记录',
			stafflog_tabledata:[],
			dialogSysUserLogVisible:false,
			edit_staff_uuid:'',
			edit_staff_name:'',
			edit_staff_pass:'',
			dialogEditSysUserVisible:false,
			input_nickname:'',
			input_account:'',
			input_pass:'',
			dialogNewfeedbackVisible:false,
			tableData:[],
			searchValue:'',
			loading:true,
			curTipsID: '', 
		}
	},
	components: {
		CommonNav,
		CommonHeader
	},
	created() {
		this.initData()
	},
	mounted() {

	},
	methods: {
		handleDetail(rowdata){
			console.log(rowdata.id);
			let post={
				token:sessionStorage.getItem('subudian_token'),
				feed_id:rowdata.id
			}
			let me = this;
			MN.getFeedbackDetail(post).then(res => {
				if( res.status == 'token_out' ){
					me.$message({
						message: '请重新登录系统',
						type: 'warning'
					});
					location.href="https://www.subudian.com";
					return
				}
				me.feedback_detail = res.detail;
				me.feedback_follow = res.list;
			})
			this.dialogDetailfeedbackVisible = true;
		},
		handleSaveNewFeedback(){
			this.loading = true
			if ( !this.feedback_body  ){
				this.$message({
				message: '请填写内容',
				type: 'warning'
				});
				return
			}
			let post={
				token:sessionStorage.getItem('subudian_token'),
				feedback:this.feedback_body
			}
			let me = this;
			MN.setSaveNewFeedback(post).then(res => {
				if( res.status == 'token_out' ){
					me.$message({
						message: '请重新登录系统',
						type: 'warning'
					});
					location.href="https://www.subudian.com";
					return
				}
				me.$message({
					message: '提交成功',
					type: 'success'
				});
				me.dialogNewfeedbackVisible = false;
				me.initData();
			})
		},
		handleNewfeedback(){
			this.dialogNewfeedbackVisible = true;
		},
		initData(){
			let me = this;
			this.loading = true
			let post={
				token:sessionStorage.getItem('subudian_token')
      		}
			MN.getFeedbackMainList(post).then(res => {
				if( res.status == 'token_out' ){
					me.$message({
						message: '请重新登录系统',
						type: 'warning'
					});
					location.href="https://www.subudian.com";
					return
				}
				this.tableData=res.list;
				this.loading=false;
			})
		},
	}
}
</script>

<style scoped>
.card_sx{ margin-bottom: 15px; }
.dox_ito{ color: #1fdb64; font-weight: bolder; }
.dil_date{ font-size: 13px; color: #a9a9a9; }
.dil_body{ font-size: 16px; color: #000000; padding: 10px 0 14px 0; }
.sxxx{ width: 100%;  }
.sixso{ margin-bottom: 20px; font-size: 14px; color: #d0d0d0; }
.sixso strong{ color: #6991c2; }
.sixo{ margin-top:15px; }
.red_dot{ color: #ff693f; }
.xootips{ color: #a9a9a9; margin-top: 4px; }
</style>
